module.exports = __webpack_public_path__ + "img/eg.eb232ce5.svg";